<template>
  <div>
    <h3>Basic</h3>
    <div class="p-grid p-justify-center">
      <div class="p-col">
        <div id="datePicker"></div>
        <AirbnbStyleDatepicker
          :sundayFirst="true"
          :months-to-show="2"
          triggerElementId="datePicker"
          :mode="'range'"
          :inline="true"
          :startOpen="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      value: 1,
      value2: 1,
    };
  },
  created() {},
  mounted() {
    console.log("Mounted");
  },
};
</script>

<style scoped lang="scss"></style>
